var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { DeskPool } from "../../DeskPool";
import { startIntroductionPhase } from "../../../../api";
import { selectMatchState, setMatchState } from "../../../../store/match";
import { useAppDispatch, useAppSelector, useQuery } from "../../../../hooks";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
export function MafiaMeets() {
    const { param: matchId } = useQuery("matchId");
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const [isLoading, setIsLoading] = useState(false);
    const onStartGameClick = () => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const result = yield startIntroductionPhase((matchState === null || matchState === void 0 ? void 0 : matchState.id) || "");
            // console.log('MatchDesk onStartGameClick', result)
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
            console.error("MatchDesk onStartGameClick error", err.response);
        }
        finally {
            setIsLoading(false);
        }
    });
    const gameButtonState = {
        text: isLoading ? "Выполняется..." : "Мафия познакомилась",
        visible: true,
        onClick: onStartGameClick,
        disabled: isLoading,
    };
    return (_jsx(DeskPool, { onPlayerClickAction: null, gameButtonState: gameButtonState }));
}
